import { Component, OnInit, Input, Inject, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DateAdapter } from '@angular/material';
import { Iceutility } from '../../services/iceutility';
import { IcecontrolSettings, IcepanelSettings, iceColumnDefinition } from '../../components/models/icesettings';
import { IcepanelComponent } from '../icepanel/icepanel.component';
import { IcematgridComponent } from '../icepanel/icematgrid.component';
import { LoginService } from '../../login/login.service';

@Component({
  selector: 'icelabel',
  templateUrl: './icelabel.component.html',
  styleUrls: ['./icelabel.component.scss']
})
export class IcelabelComponent implements OnInit {
  // Input Members
  @Input() id: string = "";
  @Input() placeholder: string;
  @Input() properties: any = {};
  @Input() ctrl: IcecontrolSettings = null;
  @Input() controlClick: EventEmitter<any> = new EventEmitter<any>();
  @Input() tableColumn: iceColumnDefinition = null;
  @Input() tableRowData: any = null;
  @Input() matTableObject: IcematgridComponent = null;

  @ViewChild('linkeditControl') linkeditControl: ElementRef;

  // Data Members
  iceFormControl: FormControl = null;
  linkEdit: boolean = false;
  slideToggleColor = 'accent';
  slideToggleChecked = false;
  slideToggleDisabled = false;

  constructor(
    @Inject(IcepanelComponent) private parent: IcepanelComponent,
    private dateAdapter: DateAdapter<Date>, private loginSvc: LoginService) {
  }

  ngOnInit() {
    try {
      if (this.matTableObject && this.tableRowData != null && this.tableColumn != null) {
        // tables should not use the standard formcontrol
        let formRowGroup: FormGroup = this.matTableObject.getFormGroup(this.tableRowData);
        this.iceFormControl = new FormControl(this.tableRowData[this.tableColumn.columnName]);
        formRowGroup.addControl(this.tableColumn.columnName, this.iceFormControl);
      }
      else if (this.ctrl == null) {
        this.iceFormControl = new FormControl(''); // No control so we create a placeholder control to prevent an errors
      }
      else {
        this.iceFormControl = this.ctrl.getFormControl();
        if (this.iceFormControl == null)
          this.iceFormControl = new FormControl(''); // No control so we create a placeholder control to prevent an errors
      }

      if (this.ctrl != null && Iceutility.isdefined(this.ctrl.properties)) {
        this.properties = this.ctrl.properties;
        if (Iceutility.isdefined(this.ctrl.properties.placeholder)) {
          this.placeholder = this.ctrl.properties.placeholder;
        }
        if (Iceutility.isdefined(this.properties.menuItems) && this.properties.menuItems.length > 0)
          this.ctrl.setOptions(this.properties.menuItems);

        if (this.getLinkMode() == 'labeldatepicker')
          Iceutility.setLocal(this.dateAdapter, this.loginSvc.currentDateFormat);
      }
    }
    catch (e) {
      console.log(e);
    }
  }

  getValue(lkMode?: string): string | number {
    if (this.matTableObject && this.tableRowData != null && this.tableColumn != null) {
      let val = this.tableRowData[this.tableColumn.columnName];
      if (lkMode == 'labeldatepicker') {
        val = Iceutility.GetLocalDate(Iceutility.convertToUTCEx(val));
        return val;
      }
      else if (lkMode == 'labelselect') {
        if (this.ctrl != null) {
          let opts = this.ctrl.getOptions().filter(o => val == o.name);
          if (opts.length > 0) {
            this.iceFormControl.setValue(opts[0].name);
            return opts[0].value;
          }
          else {
            return val;
          }
        }
      }
      switch (this.getLinkMode()) {
        case "labeledit":
        case "labeldatepicker":
        case "labelselect": {
          if ((val == "" || typeof val == "undefined") && this.linkEdit == false) {
            return this.getPlaceholder();
          }
          break;
        }
      }

      if (typeof val == "undefined")
        return "";

      if (this.getLinkMode() == "labelslidetoggle")
        return this.getDisplayValue(this.getLinkMode());

      if (this.getLinkMode() == "" && typeof val == "boolean") {
        if (this.ctrl != null && this.ctrl.properties != null && this.ctrl.properties
          && (this.ctrl.properties.onDisplayValue != null || this.ctrl.properties.offDisplayValue))
          return Iceutility.toBoolean(val) ? this.ctrl.properties.onDisplayValue : this.ctrl.properties.offDisplayValue;
      }

      this.iceFormControl.setValue(val);
      return val;
    }
    else {       
      switch (this.getLinkMode()) {
        case "labeledit":
        case "labeldatepicker":
        case "labelselect": {
          let val = this.iceFormControl.value;
          if ((val == "" || typeof val == "undefined") && this.linkEdit == false) {
            return this.getPlaceholder();
          }
          break;
        }
      }

    }
    return this.iceFormControl.value;
  }

  getDisplayValue(lkMode?: string): string {
    if (this.matTableObject && this.tableRowData != null && this.tableColumn != null) {
      let val = this.tableRowData[this.tableColumn.columnName];
      if (lkMode == 'labelslidetoggle') {
        if (this.ctrl != null && this.ctrl.properties != null && this.ctrl.properties
          && (this.ctrl.properties.onDisplayValue != null || this.ctrl.properties.offDisplayValue))
          return Iceutility.toBoolean(val) ? this.ctrl.properties.onDisplayValue : this.ctrl.properties.offDisplayValue;
      }
    }
    return "";
  }

  getStaticValue(): string {
    return this.ctrl != null && this.ctrl.properties != null && this.ctrl.properties.value != null ? this.ctrl.properties.value : "";
  }

  getPlaceholder(): string {
    return this.ctrl != null && this.ctrl.properties != null && this.ctrl.properties.placeholder != null ? this.ctrl.properties.placeholder : "";
  }

  getLabelStyle(): any {
    let style = {
      width: '100%',
      color: 'black'
    };

    if (this.ctrl == null || this.ctrl.properties == null) return style;

    if (this.ctrl.properties.width != null)
      style.width = this.ctrl.properties.width;

    if (this.ctrl.properties.color != null)
      style.color = this.ctrl.properties.color;

    if (this.ctrl.properties.cursor != null) {
      style["cursor"] = this.ctrl.properties.cursor;
    }

    if (this.ctrl.properties.display != null) {
      style["display"] = this.ctrl.properties.display;
    }

    if (this.ctrl.properties['vertical-align'] != null) {
      style['vertical-align'] = this.ctrl.properties['vertical-align'];
    }
    
    return style;
  }

  getLinkMode(): string {
    return this.ctrl != null && this.ctrl.properties != null && this.ctrl.properties.linkMode != null && this.ctrl.properties.linkMode.length > 0 ? this.ctrl.properties.linkMode : "";
  }

  getLinkEdit(): boolean {
    return this.linkEdit;
  }

  onClick(event) {
    this.linkEdit = this.getLinkMode() != "labelanchor" ? true : false;

    event.controlSettings = this.ctrl;
    if (this.matTableObject && this.matTableObject.colClick) {
      this.matTableObject.onColumnClick(event, this.tableColumn, this.tableRowData);
      if (this.linkEdit && this.getLinkMode() == "labeledit")
        setTimeout(() => {
          this.linkeditControl.nativeElement.focus();
        }, 0);        
    }
    else if (this.parent && this.parent.controlClick)
      this.parent.onControlClick(event);
    else
      this.controlClick.emit(event);
  }

  onFocusOut(event) {
    if (this.matTableObject && this.tableRowData != null && this.tableColumn != null) {
      if (this.getLinkMode() == 'labeledit' && event.currentTarget) {
        let val = this.tableRowData[this.tableColumn.columnName];
        if (val != event.currentTarget.value)
          this.tableRowData[this.tableColumn.columnName] = event.currentTarget.value;

        let formRowGroup: FormGroup = this.matTableObject.getFormGroup(this.tableRowData);
        if (formRowGroup != null) {
          let fromCtrl = formRowGroup.get(this.tableColumn.columnName);
          if (fromCtrl != null) {
            fromCtrl.setValue(event.currentTarget.value);
            fromCtrl.markAsDirty();
          }
          formRowGroup.markAsDirty();
        }
      }
    }
  }

  onDateChange(event) {
    event.controlSettings = this.ctrl;
    if (this.matTableObject && this.matTableObject.controlChange) {
      if (this.tableRowData != null && this.tableColumn != null) {
        this.tableRowData[this.tableColumn.columnName] = Iceutility.getDateTextEx(event.value);
        event.tableColumn = this.tableColumn;
        event.tableRowData = this.tableRowData;
        let formRowGroup: FormGroup = this.matTableObject.getFormGroup(this.tableRowData);
        if (formRowGroup != null) {
          let fromCtrl = formRowGroup.get(this.tableColumn.columnName);
          if (fromCtrl != null) {
            fromCtrl.setValue(this.tableRowData[this.tableColumn.columnName]);
            fromCtrl.markAsDirty();
          }
          formRowGroup.markAsDirty();
        }
      }

      this.matTableObject.onControlChange(event);
    }
    else if (this.parent && this.parent.controlChange)
      this.parent.onControlChange(event);
  }

  onSelectChange(event) {
    event.selectSettings = this.ctrl;
    if (this.matTableObject && this.matTableObject.controlChange) {
      if (this.tableRowData != null && this.tableColumn != null) {
        if (this.getLinkMode() == "labelslidetoggle") {
          this.tableRowData[this.tableColumn.columnName] = event.checked;
        }
        else {
          this.tableRowData[this.tableColumn.columnName] = event.value;
        }

        event.tableColumn = this.tableColumn;
        event.tableRowData = this.tableRowData;
        let formRowGroup: FormGroup = this.matTableObject.getFormGroup(this.tableRowData);
        if (formRowGroup != null) {
          let fromCtrl = formRowGroup.get(this.tableColumn.columnName);
          if (fromCtrl != null) {
            fromCtrl.setValue(this.tableRowData[this.tableColumn.columnName]);
            fromCtrl.markAsDirty();
          }
          formRowGroup.markAsDirty();
        }
      }

      this.matTableObject.onControlChange(event);
    }
    else if (this.parent && this.parent.controlChange)
      this.parent.onControlChange(event);
  }
}
